const Textarea = {
  variants: {
    outline: {
      bg: 'surface.default',
      borderColor: 'border.strong',
      borderRadius: 'md',
      // Mismo motivo y mismo valor que en Input: sin esto hereda la
      // escala fluida del cuerpo (16-18px) y el marcador se ve enorme al
      // lado de los demás campos del formulario.
      fontSize: '14px',
      color: 'text.primary',
      _hover: { borderColor: 'accent.default' },
      _focusVisible: {
        borderColor: 'accent.default',
        boxShadow: 'outline',
      },
      _placeholder: { color: 'text.secondary' },
    },
  },
  defaultProps: { variant: 'outline' },
};

export default Textarea;
